import { cn } from "../../lib/utils";

const HEART_PATH =
  "M12.3 20.4c-.7-.6-6.8-4.9-8.4-8.5C2.5 8.7 4 5.3 7.1 5.1c2.3-.2 3.8 1.4 4.8 3.4.7-2.1 2.5-4 5-3.8 3.1.3 4.7 3.5 3.3 6.7-1.6 3.5-6.3 7-8.2 9.3-.4.5-1 1-1.9 1.4";

const TILTS = [
  "-rotate-[8deg]",
  "rotate-6",
  "-rotate-3",
  "rotate-[10deg]",
] as const;

export interface HandHeartProps {
  /** Picks one of four tilts so hearts never look stamped. */
  index?: number;
  label?: string;
  className?: string;
}

/**
 * Hand-drawn heart in currentColor. Replaces the ♡ glyph everywhere. Website
 * only, at most one per section; it signals care, never a status or rating.
 */
export function HandHeart({
  index = 0,
  label = "hjärta",
  className,
}: HandHeartProps) {
  return (
    <span
      role="img"
      aria-label={label}
      className={cn(
        "inline-block h-[1.05em] w-[1.05em] align-[-0.18em]",
        TILTS[Math.abs(index) % TILTS.length],
        className,
      )}
    >
      <svg
        viewBox="0 0 24 24"
        width="100%"
        height="100%"
        fill="none"
        aria-hidden="true"
      >
        <path
          d={HEART_PATH}
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
